export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_13-3ba71518e17f2703deeea6eab3db4116.jpg";